<template>
	<div>
		<DetailCard :detailContent="getDetailContent">
			<template v-slot:title>
				<div class="column col-auto" :class="getState">
					{{ item.STATUS_NAME }}
				</div>
				<div
					v-if="item.STATUS_CODE === '1' || item.STATUS_CODE === '3'"
					class="column col-auto col-ml-auto"
				>
					<button
						class="rs-cancel"
						type="button"
						@click="cancelUserReservationWaiting(item.ID)"
					>
						대기취소
					</button>
				</div>
				<div
					v-if="item.STATUS_CODE === '2'"
					class="column col-auto col-ml-auto"
				>
					취소일시 {{ cancelDate }}
				</div>
			</template>
		</DetailCard>
	</div>
</template>

<script>
import DetailCard from '@/components/common/DetailCard';

import { formatDateString } from '@/utils/util';

export default {
	components: {
		DetailCard,
	},
	props: {
		item: {
			type: Object,
			default: () => {},
			required: true,
		},
	},
	computed: {
		userId() {
			return this.$store.getters['userStore/userId'];
		},
		getState() {
			return this.item.STATUS_CODE === '1' || this.item.STATUS_CODE === '3'
				? 'complete'
				: 'cancel';
		},
		getDetailContent() {
			const branchName = this.item.DEPT_NAME;
			const reservationDate = formatDateString(this.item.RSRV_DT);
			const reservationTime = this.item.RSRV_TM_NAME.replace(
				'AM ',
				'오전 ',
			).replace('PM ', '오후 ');

			return [
				{
					name: '지점',
					value: branchName,
				},
				{
					name: '날짜',
					value: reservationDate,
				},
				{
					name: '시간',
					value: reservationTime,
				},
			];
		},
		cancelDate() {
			return this.item.CANCEL_DT ? this.item.CANCEL_DT.replace(/-/g, '.') : '';
		},
	},
	methods: {
		async cancelUserReservationWaiting(ID) {
			const payload = {
				userId: this.userId,
				waitingId: ID,
			};
			const { data } = await this.$store.dispatch(
				'reservationStore/cancelUserReservationWaiting',
				payload,
			);

			const options = {
				okLabel: '확인',
				message: data.message,
			};
			this.showAlert(options).then(({ ok }) => {
				if (ok === true) {
					this.$emit('initRender');
				}
			});
		},
	},
};
</script>

<style scoped>
.rs-cancel {
	display: flex;
	justify-content: center;
	align-items: center;
	height: 1.5rem;
	padding: 0 0.625rem;
	border: 1px solid #f53838;
	border-radius: 0.6875rem;
	color: #f53838;
	font-size: 0.75rem;
	font-weight: 500;
	letter-spacing: -0.05em;
}
</style>
